import React from "react";
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import { TECarousel, TECarouselItem } from "tw-elements-react";

import './ImageListComponent.scss';

export default function Carousel() {
    return (
        <section id="gallery" className="tw-px-4 md:tw-px-16 tw-py-16 tw-bg-gray-100 md:tw-pt-[90px]">
            {/* <h3 className="section-header tw-text-center tw-pb-16">
                Revolving Highlights
            </h3> */}
            <div className="tw-flex tw-justify-center">
                <div className="md:tw-w-3/4">
                    <TECarousel touch showControls showIndicators ride="carousel">
                        <div className="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
                            <TECarouselItem
                                itemID={1}
                                className="relative float-left -mr-[100%] hidden w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                            >
                                <img
                                    src="/images/slider/IMG_7068.png"
                                    style={{ alignSelf: 'center' }}
                                    className="tw-block slider-image w-full md:tw-h-auto tw-h-[200px] md:tw-max-h-[520px]"
                                    alt="Kakariki - Welcome"
                                />
                                <div className="absolute inset-x-[15%] bottom-5 py-5 text-center text-white">
                                    {/* <h5 className="tw-text-md md:tw-text-xl tw-font-bold">Welcome to Kakariki</h5>
                                    <p className="hidden md:block">
                                        Experience fresh flavors and warm hospitality at Kakariki Café!
                                    </p> */}
                                </div>
                            </TECarouselItem>
                            {/* <TECarouselItem
                                itemID={2}
                                className="relative float-left hidden -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                            >
                                <img
                                    src="/images/slider/IMG_8600.png"
                                    className="block w-full slider-image  md:tw-h-auto tw-h-[200px] md:tw-max-h-[520px]"
                                    alt="Kakariki - Cusine"
                                />
                                <div className="absolute inset-x-[15%] bottom-5 py-5 text-center text-white md:block">
                                    <h5 className="tw-text-md md:tw-text-xl tw-font-bold">Explore the cusine</h5>
                                    <p className="hidden md:block">
                                        Savor the rich and diverse flavors of our cuisine!
                                    </p>
                                </div>
                            </TECarouselItem> */}
                        </div>
                    </TECarousel>
                </div>
            </div>

        </section>
    );
}